const ROSIE_PENDING_SITE_KEY = "newlyCreatedMicroSiteId";
const ROSIE_NEW_FLAG_KEY = "isNewlyCreatedMicroSite";
const ROSIE_SHOWN_KEY = "rosiePromptShownForSiteId";
const FORCE_OPEN_KEY = "forceOpenRosieForSiteId";

/** Rosie needs a website URL to generate draft content. */
export function hasRosieWebsiteLink(siteOrLink) {
  const link =
    typeof siteOrLink === "string" || siteOrLink == null
      ? siteOrLink
      : siteOrLink?.websiteLink ??
        siteOrLink?.website ??
        siteOrLink?.websiteUrl ??
        siteOrLink?.webLink;
  return Boolean(String(link || "").trim());
}

/** Arms Rosie so Site Features + popup open on first accordion open of this site. */
export function armRosieForNewSite(siteId) {
  if (!siteId) return;
  const id = String(siteId);
  localStorage.removeItem("rosieAiComplete");
  sessionStorage.removeItem("aiDetails");
  sessionStorage.removeItem("rosieProgressDismissed");
  localStorage.setItem(ROSIE_NEW_FLAG_KEY, "true");
  localStorage.setItem(ROSIE_PENDING_SITE_KEY, id);
  // Allow prompt again if it was marked shown for a previous attempt.
  if (localStorage.getItem(ROSIE_SHOWN_KEY) === id) {
    localStorage.removeItem(ROSIE_SHOWN_KEY);
  }
  window.dispatchEvent(
    new CustomEvent("missing-tabs-modal-close", {
      detail: { allowNewRosiePrompt: true },
    }),
  );
}

export function isRosiePendingForSite(siteId) {
  if (!siteId) return false;
  const id = String(siteId);
  if (localStorage.getItem(ROSIE_SHOWN_KEY) === id) return false;
  return (
    localStorage.getItem(ROSIE_NEW_FLAG_KEY) === "true" &&
    localStorage.getItem(ROSIE_PENDING_SITE_KEY) === id
  );
}

/**
 * Allow Site Features + Rosie for this pending site (manual click, or
 * single-site auto-open after approval when a website link exists).
 */
export function markForceOpenRosieForSite(siteId) {
  if (!siteId) return false;
  const id = String(siteId);
  // Do not reassign pending Rosie to a different site.
  if (!isRosiePendingForSite(id)) return false;
  sessionStorage.setItem(FORCE_OPEN_KEY, id);
  return true;
}

/** True when org has exactly one site — refresh auto-open may also show Rosie. */
export function isSingleMicrositeOrg(sites) {
  return Array.isArray(sites) && sites.length === 1;
}

export function consumeForceOpenRosieForSite(siteId) {
  if (!siteId) return false;
  const id = String(siteId);
  if (sessionStorage.getItem(FORCE_OPEN_KEY) !== id) return false;
  sessionStorage.removeItem(FORCE_OPEN_KEY);
  return true;
}

export function markRosiePromptShown(siteId) {
  if (!siteId) return;
  localStorage.setItem(ROSIE_SHOWN_KEY, String(siteId));
}

export function clearRosiePendingFlags() {
  localStorage.setItem(ROSIE_NEW_FLAG_KEY, "false");
  localStorage.removeItem(ROSIE_PENDING_SITE_KEY);
  sessionStorage.removeItem(FORCE_OPEN_KEY);
}

/**
 * If the pending site has no website, skip Rosie permanently for that site
 * so Site Features + Rosie do not open (and no other site is used instead).
 */
export function skipRosieIfNoWebsite(site) {
  if (!site?.id) return true;
  if (hasRosieWebsiteLink(site)) return false;
  if (!isRosiePendingForSite(site.id)) return true;
  clearRosiePendingFlags();
  markRosiePromptShown(site.id);
  return true;
}
